import { pathToRegexp, match, parse, compile } from "path-to-regexp"

export const matchPath = (pathname, params) => {
    if (!params.path) {
        return null
    }
    const regexp = pathToRegexp(params.path, [], params)
    const r = regexp.exec(pathname)
    return r
}